import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AccessChecker } from './access-checker.service';

/**
 * Unified route guard that supersedes the stacked `PermissionGuard` /
 * `SubscriptionPlanGuard` / `FeatureFlagGuard`. Because every gated route spreads
 * its feature-owned access descriptor into `data` (see the `*.access.ts` files),
 * the guard reads that same `AccessConstraint` straight from the route's
 * `data` — no registry, no URL matcher — and allows, redirects (feature-flag /
 * plan denial) or cancels with a toast (permission denial). A route whose `data`
 * declares no access fields is unrestricted. The snapshot travels alongside its
 * `data` so a redirect can carry over the params the denied route was entered with.
 *
 * Attach it once per gated route in place of the deprecated stacked guards; the
 * three dimensions are evaluated together, in a single guard.
 */
export const accessGuard: CanActivateFn = (route): Observable<boolean | UrlTree> =>
  inject(AccessChecker).check(route.data, route);
